module.exports = __webpack_public_path__ + "static/media/RaisingChildren_ios_1.1f29113c.jpg";